module.exports = __webpack_public_path__ + "static/media/mobile.6e2c9e6a.png";